import React from "react";
import { Link } from "react-router-dom";
import { MenuItem } from "@chakra-ui/react";

interface BusinessMenuItemProps {
  path: string;
  icon: React.ReactElement;
  children: React.ReactNode;
}

export const BusinessMenuItem = ({
  path,
  icon,
  children,
}: BusinessMenuItemProps) => {
  return (
    <MenuItem icon={icon} as={Link} to={path} fontSize="sm">
      {children}
    </MenuItem>
  );
};
